import { NeoModel } from "@singularsystems/neo-core";
import { Views } from "@singularsystems/neo-react";
import CorporateActionEventLookup from "../Models/Lookups/CorporateActionEventLookup";
import Types from "../../../App/AppTypes";
import { AppService } from "../../../App/Services/AppService";

@NeoModel
export default class ManageCorporateActionEventComponentVM extends Views.ViewModelBase {
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public corporateActionEventsApiClient = AppService.get(Types.ApiClients.CorporateActionEventsApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
    }
    public managedCorporateActionEvent = new CorporateActionEventLookup();
}